import { render, staticRenderFns } from "./FilterDetailBox.vue?vue&type=template&id=1ae4ee02&scoped=true&"
import script from "./FilterDetailBox.vue?vue&type=script&lang=js&"
export * from "./FilterDetailBox.vue?vue&type=script&lang=js&"
import style0 from "./FilterDetailBox.vue?vue&type=style&index=0&id=1ae4ee02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4ee02",
  null
  
)

export default component.exports